document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collapsible-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var contentId = btn.getAttribute('aria-controls');
      var content = document.getElementById(contentId);
      if (!content) return;

      if (expanded) {
        content.style.height = '0px';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        content.style.height = content.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});